import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { registerUser, loginUser } from '../services/api';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    password: '', // Add password to form state
    phone: '',
    nationality: '',
  assistant_name: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const requestedPlan = params.get('plan');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!formData.full_name || !formData.email || !formData.password) {
      setError('Nombre completo, email y contraseña son requeridos.');
      return;
    }

    try {
      await registerUser(formData);
      // After registration, auto-login the user so we can redirect to purchase if a plan was requested
      try {
        const body = new URLSearchParams();
        body.append('username', formData.email);
        body.append('password', formData.password);
        await loginUser(body as unknown as FormData);
      } catch (loginErr) {
        // If auto-login fails, proceed to login page
      }

      if (requestedPlan) {
        // Redirect to pricing with plan query so the user can complete purchase
        navigate(`/pricing?plan=${encodeURIComponent(requestedPlan)}`);
        return;
      }

      setSuccess('¡Registro exitoso! Serás redirigido a la página de login.');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error: any) {
      setError(error.message);
    }
  };

  return (
    <div className="light-theme-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body p-4">
                <h3 className="card-title text-center mb-4">Regístrate gratis y comienza a organizar tu vida</h3>
                <form onSubmit={handleSubmit}>
                  {error && <div className="alert alert-danger">{error}</div>}
                  {success && <div className="alert alert-success">{success}</div>}
                  
                  <div className="mb-3">
                    <label htmlFor="full_name" className="form-label">Nombre completo</label>
                    <input type="text" className="form-control" id="full_name" name="full_name" value={formData.full_name} onChange={handleChange} required placeholder="Ejemplo: Juan Pérez" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Correo electrónico</label>
                    <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="ejemplo@email.com" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Contraseña</label>
                    <input type="password" className="form-control" id="password" name="password" value={formData.password} onChange={handleChange} required placeholder="Mínimo 6 caracteres" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Teléfono</label>
                    <input type="tel" className="form-control" id="phone" name="phone" value={formData.phone} onChange={handleChange} required placeholder="Ejemplo: +54 9 11 1234-5678" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="nationality" className="form-label">Nacionalidad (opcional)</label>
                    <input type="text" className="form-control" id="nationality" name="nationality" value={formData.nationality} onChange={handleChange} placeholder="Ejemplo: Argentina" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="assistant_name" className="form-label">Nombre de tu asistente (opcional)</label>
                    <input type="text" className="form-control" id="assistant_name" name="assistant_name" value={formData.assistant_name} onChange={handleChange} placeholder="Ejemplo: CUDA, Sofía, Max..." style={{color: '#888', fontStyle: 'italic'}} />
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      Crear cuenta gratis
                    </button>
                  </div>
                </form>
                <div className="text-center mt-3">
                  <p>
                    ¿No tienes una cuenta de Telegram? <a href="https://telegram.org/dl" target="_blank" rel="noopener noreferrer">Descárgala aquí</a>
                  </p>
                  <p>
                    ¿Ya tienes una cuenta? <Link to="/login">Inicia sesión</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
